import { emotionTheme } from '@styles/theme'
import { Box } from '@mui/material'
import styled from '@emotion/styled'

export const tooltipStyles = {
  backgroundColor: emotionTheme.colors.lightest,
  color: emotionTheme.colors.secondary,
  fontSize: '10px',
  lineHeight: '150%',
  fontWeight: 400,
  padding: '10px',
  borderRadius: '4px',
  maxWidth: '400px',
  boxShadow: `0px 2px 4px 0px rgba(0, 0, 0, 0.2)`
}

export const arrowStyles = {
  color: `${emotionTheme.colors.lightest} !important`
}

export const Content = styled(Box)`
  width: 100%;
`
